/**
 * Enables CSS animation for the desktop menu.
 *
 * This function returns an event listener that removes the animation-out class from the menu,
 * sets the menu's display style to 'none', and prevents the default action and propagation of the event.
 *
 * @param {HTMLElement} menu - The menu element to enable CSS animation for.
 * @param {Object} itemParams - Item-specific parameters.
 * @param {Object} itemParams.desktop - Desktop-specific parameters.
 * @param {string} itemParams.desktop.animationOut - The class for the animation-out effect.
 * @returns {Function} - The event listener function.
 */
export default function desktopCSSAnimationEnable(menu, itemParams) {
  return function (e) {
    if (menu.classList.contains(itemParams.desktop.animationOut)) {
      menu.classList.remove(itemParams.desktop.animationOut);
      menu.style.display = 'none';
    }

    e.preventDefault();
    e.stopPropagation();
  };
}
